import React, {useState} from 'react';
import Select from "react-select";
import PropTypes from "prop-types";
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {filterBarSelectStyles} from "../../styles/reactSelectStyles";


const FilterSelect = ({
                        fieldName,
                        valueName,
                        options,
                        placeholder = '',
                        noOptionsMessage = () => 'אין אפשרויות',
                        styles = filterBarSelectStyles,
                        handleSubmit,
                        setFieldValue,
                        containerStyles = 'col-lg',
                      }) => {
  const [selectValue, setSelectValue] = useState({key: null});

  return (
    <div className={containerStyles}>
      <Select
        name={fieldName}
        value={options.filter(({value}) => value == valueName)}
        onChange={({value}) => {
          setSelectValue({...selectValue, key: value});
          setFieldValue(`${fieldName}`, `${value}`);
          handleSubmit();
        }}
        options={options}
        styles={styles}
        placeholder={placeholder}
        noOptionsMessage={noOptionsMessage}
      />
      <div
        className={'clear-filter-icon'}
        onClick={() => {
          setFieldValue(`${fieldName}`, '');
          handleSubmit();
          setSelectValue({key: null});
        }}
      >
        <img
          src={toAbsoluteUrl('/media/svg/Cross_brandColor.svg')}
          alt="clear-filter"
        />
      </div>
    </div>
  );
}

FilterSelect.propTypes = {
  fieldName: PropTypes.string.isRequired,
  valueName: PropTypes.string,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  styles: PropTypes.object,
  handleSubmit: PropTypes.func,
  setFieldValue: PropTypes.func,
};

export default FilterSelect;
